import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider, Grid, Paper, Typography } from '@material-ui/core';
import { Charting } from 'components';
import moment from 'moment';

import { StatsGrouping, useUserEngagementStatsQuery } from 'api';
import { useCurrentUser, useNotify } from 'hooks';

import Value from './Value';

const InternalPosts: FC = () => {
  const currentUser = useCurrentUser();
  const notify = useNotify();
  const { t } = useTranslation();

  const [variables, setVariables] = useState({
    grouping: StatsGrouping.Year,
    value: moment().year(),
  });

  const { data, isLoading } = useUserEngagementStatsQuery(
    { user_id: currentUser.id, grouping: variables.grouping, value: variables.value },
    {
      onError: notify.queryError,
    }
  );

  const { userEngagementStats } = data || {};
  const { posts, comments, reactions } = userEngagementStats || {};

  return (
    <Paper>
      <Box paddingLeft={3} paddingTop={3} marginBottom={2}>
        <Typography variant="h6">{t('components:myActivity')}</Typography>
      </Box>
      <Box paddingLeft={3} paddingRight={3} paddingBottom={2}>
        <Grid container>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              {t('common:post_plural')}
            </Typography>
            <Value isLoading={isLoading} value={posts} />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              {t('common:like_plural')}
            </Typography>
            <Value isLoading={isLoading} value={reactions} />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="subtitle2" color="textSecondary">
              {t('common:comment_plural')}
            </Typography>
            <Value isLoading={isLoading} value={comments} />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Box paddingLeft={1}>
        <Charting.PeriodSelect variables={variables} onChange={changed => setVariables(changed)} />
      </Box>
    </Paper>
  );
};

export default InternalPosts;
